import React, { useState } from "react";
import { Button } from "antd";
// import { UpCircleOutlined } from "@ant-design/icons";
import Icon from "@assets/icon_config";
import "./scrollButton.scss";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 250) {
      setVisible(true);
    } else if (scrolled <= 250) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    });
  };

  window.addEventListener("scroll", toggleVisible);

  return visible ? (
    <span className="scroll-to-top-button">
      <Button onClick={scrollToTop} type="primary" style={{ position: "sticky", bottom: "150px", left: "calc(100vw - 7rem)", width: "1.5rem" }}>
        {/* <UpCircleOutlined /> */}
        <Icon name="doubleArrowUp"/>
      </Button>
    </span>
  ) : null;
};

export default ScrollToTopButton;
